import { Component, OnChanges, Input, Inject, ElementRef, HostListener, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { encapsulation } from '../../../encapsulation';
import { UBXFieldBase, UBXField, UBXFieldOption } from '../../../../models';
import { UBXOptionComponent } from '../option/option.component';
import { UBXFieldBlockComponent } from '../../block/field-block.component';

@Component({
    selector: 'ubx-select',
    templateUrl: './select.component.html',
    host: { class: 'ubx-select flx f-fd:c f-jc:c f-fg:1 p:rl pointer' },
    encapsulation,
    animations: [
        trigger('toggleBox', [
            transition(':enter', [
                style({ opacity: 0 }), animate('0.1s ease-in', style({ opacity: 1 }))
            ]),
        ]),
    ],
})
export class UBXSelectComponent extends UBXFieldBase implements OnChanges {
    @Input() field: UBXField;

    selectedLabel: string;
    isOpen: boolean;

    @ViewChild('optionsBox') box: ElementRef;
    @ViewChildren(UBXOptionComponent) options: QueryList<UBXOptionComponent>;

    constructor(
        @Inject(UBXFieldBlockComponent) private block: UBXFieldBlockComponent,
        private el: ElementRef,
    ) {
        super();
    }

    ngOnChanges() {
        this.block.value = true;
        this.setSelectedLabel(this.model);
        setTimeout(() => this.setSelected(this.model));
    }

    setSelectedLabel(value: any) {
        let selected: UBXFieldOption<any>;
        if (this.field.select?.options) {
            selected = this.field.select?.options.find((opt) => opt.value === value);
            this.selectedLabel = selected ? selected.label : undefined;
        }
        let groupOptions: Array<UBXFieldOption<any>>;
        if (this.field.select?.groups) {
            this.field.select?.groups.forEach((group) => {
                groupOptions = groupOptions.concat(group.options);
                selected = groupOptions.find((opt) => opt.value === value);
            });
            this.selectedLabel = selected ? selected.label : undefined;
        }
    }

    setSelected(value: any) {
        this.model = value;
        this.modelChange.emit(this.model);
    }

    unsetSelected() {
        this.setSelected(undefined);
    }

    @HostListener('document:click', ['$event']) onClick(event: MouseEvent) {
        this.block.hover = false;
        this.block.focus = false;
        const insideClick = this.el.nativeElement.contains(event.target);
        this.isOpen = !insideClick ? false : this.isOpen ? false : true;
        if (insideClick) {
            setTimeout(() => {
                this.block.focus = true;
                const selected = this.options.find((opt) => opt.selected === true);
                if (selected) {
                    const item = selected.el.nativeElement;
                    const parent = this.box.nativeElement;
                    parent.scrollTop = item.offsetTop - (item.offsetHeight * 2);
                }
            });
        }
    }
}
